import { useState } from 'react'
import { FaInstagramSquare, FaReddit, FaTiktok, FaTwitterSquare } from 'react-icons/fa'

import styled from 'styled-components'
import { createMessage } from '../../api/firebase'
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 3rem;
    a{
        text-decoration: none;
        color: #333;
        transition: all 0.3s ease-in-out;
        &:hover{
            color: aquamarine;
        }
    }   

    .socials{
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    form { 
        width: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        box-shadow: 1px 1px 4px rgba(0,0,0,0.3);
        padding: 20px;
        border-radius: 5px;
        input , textarea { 
            width: 100%;
            margin: 1rem auto;
            border-radius: 6px;
            border: none;
            box-shadow: 1px 1px 4px rgba(0,0,0,0.3);
            padding: 10px 1ch;
            font-size: 16px;
            resize: none;
        }
        textarea{
            height: 200px;
            padding-top: 1;
        }
    }

`

const Contact = () => {

  const [contactName, setContactName ] = useState("")
  const [contactEmail,setContactEmail] = useState("")
  const [subject,setSubject] = useState("")
  const [message,setMessage] = useState("")
  const [error,setError] = useState("")
  const [ success,setSuccess ] = useState("")

  const sendContactForm = async ( e ) => { 
      e.preventDefault()

      if(!contactName || !contactEmail || !subject || !message) {
          return setError("Please provide all fields")
      }

      const response = await createMessage(contactName,contactEmail,subject,message);
      if(response !== true ){
          setError("Failed to complete this request. Please try again later.")
          setTimeout(()=>{
            window.location.reload()  
          }, 3000)
      }

      setSuccess(`Thank you ${contactName} for sending a message. I will respond to ${contactEmail} as soon as I get the chance!`)
      setSubject("")
      setMessage("")

  } 


  return (
    <Wrapper>
        <form onSubmit={sendContactForm}>
            {error && <span className='error_message'>{error}</span>}
            <h3>Send A Message</h3>
            <input type="text" name="contactName" id='contactName' value={contactName} placeholder="enter your name"  onChange={e=>setContactName(e.target.value)} />
            <input type="text" name="contactEmail" id='contactEmail' value={contactEmail} placeholder="enter your email" onChange={e=>setContactEmail(e.target.value)} />
            <input type="text" name="subject" id='subject' value={subject} onChange={e=>setSubject(e.target.value)} placeholder="enter a subject " />
            <textarea name="message" id="message" value={message} onChange={e=>setMessage(e.target.value)} placeholder="enter a message here" />
            <button className="btn-sbmt" type='submit'>Send Message</button>

        </form>
   
    </Wrapper>
  )
}

export default Contact